import { Change, ChangeType, Element } from '@ritabygglov/core';

const bumpVersion = <E extends Element>(object: E, userId: string): E => ({
  ...object,
  userVersion: {
    userId,
    version: object.userVersion.version + 1,
  },
});

const buildChange = (
  object: Element,
  changeType: ChangeType,
  ephemeral: boolean
): Change => ({
  createdAt: new Date().toISOString(),
  elementType: object.type,
  object,
  changeType,
  ephemeral,
});

export const createCreateChange = (
  element: Element,
  ephemeral = false
): Change => buildChange(element, ChangeType.Create, ephemeral);

export const createUpdateChange = (
  element: Element,
  ephemeral: boolean,
  userId: string
): Change =>
  buildChange(bumpVersion(element, userId), ChangeType.Update, ephemeral);

export const createDeleteChange = (
  element: Element,
  userId: string
): Change | null => {
  if (!element) {
    // In the event that a selected element has been deleted already.
    return null;
  }

  return buildChange(bumpVersion(element, userId), ChangeType.Delete, false);
};
